export default __webpack_public_path__ + "static/montserrat-v14-latin-300-45ef7de714a0d0c090047e21d590ba0f.eot";